import { render, staticRenderFns } from "./Bbei.vue?vue&type=template&id=7dc1a3f5&scoped=true"
import script from "./Bbei.vue?vue&type=script&lang=js"
export * from "./Bbei.vue?vue&type=script&lang=js"
import style0 from "./Bbei.vue?vue&type=style&index=0&id=7dc1a3f5&prod&lang=css"
import style1 from "./Bbei.vue?vue&type=style&index=1&id=7dc1a3f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc1a3f5",
  null
  
)

export default component.exports